module.exports = __webpack_public_path__ + "img/icon011.61236e56.png";